// A maintenance/project due date is a CALENDAR date: the date input sends "2026-09-20", the API stores it as the
// naive datetime 2026-09-20T00:00:00 and returns it without a zone. Reading that as a UTC instant made it 03:00
// in Israel, so an item due today turned red after 03:00 on its due day. It is overdue only once that day is over.
const pad = (n) => String(n).padStart(2, "0");

export function isDueDatePast(iso, now = new Date()) {
  const day = String(iso || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
  const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
  return day < today;
}
